import React from "react";
import { useTranslation } from "react-i18next";
import { getCountryCode } from "../../../../../utils/Internationalization/handleAppInternationalization";

const EcoProBenefitPoints = () => {
    const { t } = useTranslation(["translation"]);
    const countryCode = getCountryCode();
    return (
        <ul>
            <li>{t("BENEFITS_OF_SUPPLIES.POINT_2")}</li>
            <li>{t("BENEFITS_OF_SUPPLIES.POINT_1")}</li>
            <li>{t("BENEFITS_OF_SUPPLIES.POINT_3")}</li>
            {countryCode === "IT" 
                ? null
                : <li>{t("BENEFITS_OF_SUPPLIES.POINT_4")}</li>
            }
        </ul>
    )
}

export default EcoProBenefitPoints;